import request from '../../http/request'

export const sortOutSku = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/product/sortOut`, { params })
}
